/* Modulus — Smooth close animation for mobile hamburger drawer
   Uses the same lifecycle pattern as the cart drawer:
   1. Add .modulus-drawer-closing class to trigger close animation
   2. Wait for animation to actually finish (via getAnimations)
   3. Remove [open] attribute */

(function () {
  function waitForAnimations(element) {
    var animations = [];
    if (element.getAnimations) {
      animations = element.getAnimations({ subtree: true });
    }
    if (!animations.length) {
      // No animations found — fallback to timeout
      return new Promise(function (resolve) { setTimeout(resolve, 400); });
    }
    var promises = animations.map(function (anim) {
      return anim.finished.catch(function () {});
    });
    return Promise.all(promises);
  }

  function setup() {
    var detailsElements = document.querySelectorAll(
      '.menu-drawer-container, details[id*="menu-drawer"], details[id*="Details-menu-drawer"]'
    );

    detailsElements.forEach(function (details) {
      var drawer = details.querySelector('.menu-drawer');
      var summary = details.querySelector('summary');
      var closeBtn = details.querySelector('.menu-drawer__close-button, .close-button');
      var backdrop = details.querySelector('.menu-drawer__backdrop');

      if (!drawer) return;

      function closeWithAnimation(e) {
        if (!details.hasAttribute('open')) return;
        if (details.classList.contains('modulus-drawer-closing')) return;

        if (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }

        details.classList.add('modulus-drawer-closing');

        waitForAnimations(drawer).then(function () {
          details.removeAttribute('open');
          details.classList.remove('modulus-drawer-closing', 'menu-open');
        });
      }

      // Summary (toggle): if open, close with animation
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (details.hasAttribute('open') && !details.classList.contains('modulus-drawer-closing')) {
            closeWithAnimation(e);
          }
        }, true);
      }

      // Close button
      if (closeBtn) {
        closeBtn.addEventListener('click', closeWithAnimation, true);
      }

      // Backdrop click
      if (backdrop) {
        backdrop.addEventListener('click', closeWithAnimation, true);
      }

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && details.hasAttribute('open') && !details.classList.contains('modulus-drawer-closing')) {
          closeWithAnimation(e);
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
